import { Routes } from '@angular/router';

import { CalendarDemoComponent } from './calendar-demo.component';

export const calendarRoutes: Routes = [
  { path: 'calendar', component: CalendarDemoComponent },
];



// WEBPACK FOOTER //
// ./src/app/calendar/calendar.routes.ts